import { REGISTER_TASK, REGISTER_TASK_SUCCESSFUL, REGISTER_TASK_FAILED } from './actionTypes';

const initialState = {
    registrationTaskError: null, messageTask: null, loadingCreateTask: false
}

const registerTask = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_TASK:
            state = {
                ...state,
                loadingCreateTask: true,
                registrationTaskError: null
            }
            break;
        case REGISTER_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingCreateTask: false,
                messageTask: action.payload,
                registrationTaskError: null
            }
            break;
        case REGISTER_TASK_FAILED:
            state = {
                ...state,
                messageTask: null,
                loadingCreateTask: false,
                registrationTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default registerTask;